import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="w-full bg-soft px-3 py-6 sm:px-5" data-id="element-115" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-2xl rounded-2xl border-2 border-green/40 bg-white p-4 text-center" data-id="element-116" data-mp="223epbw9b5t8q">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-green/15 px-2.5 py-0.5 font-head text-[10px] uppercase tracking-wide text-green-dark sm:text-xs" data-id="element-117" data-mp="1x4l8puyq5m4c">
          <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-118" data-mp="19co4oq1inyds" />
          Zero Risk
        </span>
        <h2 id="guarantee-title" className="mt-1 font-head text-2xl uppercase leading-none text-navy sm:text-4xl" data-id="element-119" data-mp="14dtg17gvbflr">
          7-Day Money-Back Guarantee
        </h2>
        <p className="mt-1.5 text-[13px] font-semibold leading-snug text-navy" data-id="element-120" data-mp="1ec98bdrmsuwu">
          Explore KIDS LEARNING READY™ and see how it fits the way you help children learn.
        </p>
        <p className="mt-1 text-[13px] leading-snug text-muted" data-id="element-121" data-mp="lo52ms928hu5">
          If it isn’t right for you, contact us within 7 days and request a refund.
        </p>
        <p className="mt-1.5 font-head text-[11px] uppercase tracking-widest text-green-dark" data-id="element-122" data-mp="tymf0008r8v0">
          Your purchase is protected.
        </p>
      </div>
    </section>;
}